
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Settings, Bell } from "lucide-react";
import { cn } from "@/lib/utils";
import { Capacitor } from '@capacitor/core';

export function ProfileMobileNav() {
  const isIOS = Capacitor.getPlatform() === 'ios';
  
  return (
    <div className={cn(
      "absolute right-0 top-0 z-10 flex items-center gap-2"
      // Removed the ios-safe-area-top class here as we're handling it at the body level now
    )}>
      <Link to="/notifications">
        <Button variant="ghost" size="icon">
          <Bell className="h-5 w-5" />
        </Button>
      </Link>
      <Link to="/settings">
        <Button variant="ghost" size="icon">
          <Settings className="h-5 w-5" />
        </Button>
      </Link>
    </div>
  );
}
